import React from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { Table, IconButton } from '../../styles';

const NewsTable = ({ newsItems, onEdit, onDelete, isLoading }) => {
    return (
        <div>
            {isLoading ? (
                <p>Chargement...</p>
            ) : (
                <Table>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Catégorie</th>
                            <th>Type</th>
                            <th>Description (FR)</th>
                            <th>Description (EN)</th>
                            <th>Description (ES)</th>
                            <th>Modifier</th>
                            <th>Supprimer</th>
                        </tr>
                    </thead>
                    <tbody>
                        {newsItems.map((item) => (
                            <tr key={`${item.articleId}-${item.id}`}>
                                <td>{item.date}</td>
                                <td>{item.category}</td>
                                <td>{item.type}</td>
                                <td>{item.descriptionFR}</td>
                                <td>{item.descriptionEN}</td>
                                <td>{item.descriptionES}</td>
                                <td>
                                    <IconButton onClick={() => onEdit(item)}>
                                        <FaEdit />
                                    </IconButton>
                                </td>
                                <td>
                                    <IconButton onClick={() => onDelete(item.articleId, item.id)}>
                                        <FaTrash />
                                    </IconButton>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </div>
    );
};

export default NewsTable;
